import { router } from '@inertiajs/vue3';

export const checkRedirect = field => {
    if (!field.redirect || window.location.href.startsWith(field.redirect)) return false;

    router.visit(field.redirect);
    return true;
};
